const types = {
    SET_REPLENISHMENT: '[REPLENISHMENT] SET REPLENISHMENT',
}

export {
    types
}